// Track previous status for selectedIndex

import React, { ReactNode, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  TextField,
  FormControl,
  MenuItem,
  Select,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  Slider,
  IconButton,
  OutlinedInput,
  FormHelperText,
  CardHeader,
  TextareaAutosize,
  Checkbox,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  DialogContentText,
  LinearProgress,
  Divider,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import withSpinner from "../../HOC/withSpinner";
import { ImageGalleryProps } from "../../types/interface";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { FileDownloadOutlined, FilterAltOutlined } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import totalImages from "../../assets/icons/Images.svg";
import datasetIcon from "../../assets/icons/datasetIcon.svg";
import startTrainingInActive from "../../assets/icons/startTrainingInActive.png";
import startTrainingActive from "../../assets/icons/startTrainingActive.svg";
import datacount from "../../assets/img/datacount.svg";
import EPOCHS from "../../assets/img/epochs.svg";
import ModelName from "../../assets/img/modelName.svg";
import {
  LabelCount,
  ProjectTrain,
} from "../../types/interface/ProjectTrain.interface";
import HorizontalBarChart from "../../components/VisionStudioChart/HorizontalBarChart";
import SplitSlider from "../../components/VisionStudioSlider/SplitSlider";
import { initialDataIdDetails, useTrain } from "./TrainContext";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProjectTrain,
  fetchLabelCount,
  fetchModels,
  fetchProjectTrain,
  fetchTrainingStatus,
  removeTraining,
  updateProjectTrain,
  fetchConfusionMatrix,
  clearModelData,
  publishModel,
  fetchProjectTrainAll,
} from "../../store/slice/ProjectTrainSlice";
import { AppDispatch, RootState } from "../../store/store";
import { toast } from "react-toastify";
import {
  fetchProjectById,
  fetchProjects,
} from "../../store/slice/projectHandler";
import { useProjects } from "../Upload/projectsContext";
import train from "../../assets/icons/train.png";
import LineChart from "../../components/VisionStudioChart/LineChartForTrain";
import { VisionStudioSpinner } from "../../components";
import UploadedImage from "../../components/VisionStudioModal/UploadImage/UploadedImage";
import trainProcess from "../../assets/img/trainprocess.mp4";
import ConfusisonMetrixPNG from "../../assets/img/confusion_matrix.png";
import PCurvePNG from "../../assets/img/P_curve.png";
import RCurvePNG from "../../assets/img/R_curve.png";
import ResultPNG from "../../assets/img/results.png";
import LoaderGIF from "../../assets/img/loader.gif";
import { autoBatchEnhancer } from "@reduxjs/toolkit";
import { Project } from "../Topbar";
import DownloadIcon from "@mui/icons-material/Download";
import { AxiosProgressEvent } from "axios";
import { downloadTest } from "../../store/slice/ProjectTestSlice";
import RangeSelect from "./RangeSelect";
import trainModel from "../../assets/img/train_model.png";
import crunching from "../../assets/img/crunching3.mp4";
import finalResult from "../../assets/img/final.mp4";
import dataProcess from "../../assets/img/data-running.mp4";
import PublishIcon from "../../assets/img/publish-icon.png";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import ConfusionMatrix from "../Model/confusionMatrix";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CloseIcon from "@mui/icons-material/Close";
import ResponsiveTooltip from "../../components/CustomTooltip/CustomTooltip";
import oneimg from "../../assets/img/23.svg";
import twoimg from "../../assets/img/24.svg";
import threeimg from "../../assets/img/25.svg";
import fourimg from "../../assets/img/26.svg";
import fiveimg from "../../assets/img/27.svg";
import siximg from "../../assets/img/28.svg";
import sevenimg from "../../assets/img/29.svg";
import eightimg from "../../assets/img/30.svg";
import nineimg from "../../assets/img/31.svg";
import tenimg from "../../assets/img/32.svg";
import elevenimg from "../../assets/img/33.svg";
import twelveimg from "../../assets/img/34.svg";
import thirteenimg from "../../assets/img/35.svg";
import fourteenimg from "../../assets/img/36.svg";
import fifteenimg from "../../assets/img/37.svg";
import sixteenimg from "../../assets/img/38.svg";
import seventeenimg from "../../assets/img/39.svg";
import eighteenimg from "../../assets/img/40.svg";
import nineteenimg from "../../assets/img/41.svg";
import twentyimg from "../../assets/img/42.svg";
import twentyoneimg from "../../assets/img/43.svg";
import ConfusionMatrixIframe from "./ConfusionMatrixIframe";
import AuthenticatedReportImage from "./AuthenticatedReportImage";
import { json } from "stream/consumers";
import TrainPageSkeleton from "../../components/VisionStudioPlaceholders/TrainPageSkeleton";
import { fetchTrainValidation } from "../../store/slice/WorkFlowSlice";

export const disabledIds = [
  "fdc08d25-95ca-40f6-8344-14f274ebecc7",
  "0d83fbef-d8ba-4a0f-9a00-1b4597405347",
  "78552371-2437-45f4-926f-9b2a9c1b0b58",
  "3a0b932f-ee2f-4ef7-97f0-c8a57779ce5d",
  "9564bf6e-eab4-4bf9-aa95-4124e6941c32",
  //"9b09f942-27c6-4a99-915d-c0e699c194b6",
];

type Tooltips = {
  [key: string]: string; // Define the structure of the tooltips object
};

export const tooltips: Tooltips = {
  "1749ebb6-5f27-44c6-9de6-07d65adfe94d":
    "Developed by Microsoft, this model comes pretrained on the ImageNet-1K, ImageNet-21K dataset",
  "fdc08d25-95ca-40f6-8344-14f274ebecc7":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "0d83fbef-d8ba-4a0f-9a00-1b4597405347":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "02a845d3-a83a-4606-8e2e-20e66e0f61c6":
    "Developed by Facebook, this model comes pretrained on coco, LVIS, Imagenet dataset.",
  "f9cc0c0c-69da-4112-afca-2838e4d1dc17":
    "license: AGPL 3.0, Developed by: Ultralytics, Weights trained on: COCO",
  "db90fb9c-b8d8-466a-af1d-2c7499081ca4":
    "Improves accuracy with better feature extraction and segmentation",
  "0f98d180-f3ed-46d0-9f20-2db00ef97274":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "0869b954-2799-48b9-a74d-2f6c6b1bfb8f":
    "license: MIT, Developed by: MultimediaTechLab, Weights trained on: COCO",
  "c8032570-7744-422b-acd1-34bd6d0c3a98":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "9564bf6e-eab4-4bf9-aa95-4124e6941c32":
    "Developed by University of Oxford, this model comes pretrained on ImageNet-1K dataset.",
  "d8e87b18-61c5-43a3-b3e6-42564f40329a":
    "license: AGPL 3.0, Developed by: Ultralytics, Weights trained on: COCO",
  "764059dd-0e19-4d3c-b950-4772e0d7e3d3":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "5e6acb8c-97a9-4c9d-ac70-50f96fd291c3":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "64985edf-93ec-4e6c-9cb5-5586aa11a23c":
    "license: AGPL 3.0, Developed by: Tsinghua University, Weights trained on: COCO",
  "bebf321a-a4cb-4655-91b4-55e077e51427":
    "Uses PGI and GELAN to reduce computation and improve accuracy",
  "4c8dede-54bf-4adc-aeb4-6f3dea910193":
    "Developed by Alibaba DAMO Academy, this model comes pretrained on coco dataset.",
  "13b94b6e-9c57-43c2-89b5-7ffbf7fe7bb7":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "aafd2d94-8361-4b47-8381-8199de8a3ac8":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "4f895d1e-40a7-43ce-aa11-8661f0ca68d0":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "9ed75afc-cea6-4bb3-9e93-8c332fe2eaaa":
    "Developed by Google Research, this model comes pretrained on the ImageNet-21K, JFT-300 dataset.",
  "af560b81-97d6-4698-b4d4-97c45495b4f5":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "78552371-2437-45f4-926f-9b2a9c1b0b58":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "133171c7-3e71-4eca-841a-9e30fd111f15":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "4c22822d-e12e-4fa5-b432-a7d4ca3e87e9":
    "license: AGPL 3.0, Developed by: Ultralytics, Weights trained on: COCO",
  "d4bc435e-237c-45b2-a2a8-b74b085b9d85":
    "Developed by University of Oxford, this model comes pretrained on ImageNet-1K dataset.",
  "e4e8a9d1-1f38-41b8-877f-bf9b3641ce66":
    "Developed by Google Research, this model is pretrained on COCO, PASCAL VOC, and ADE20K dataset",
  "b88b8b25-44bc-4566-ac1a-c054a95bf9b0":
    "Developed by Google Research, this model is pretrained on COCO, PASCAL VOC, and ADE20K dataset",
  "9b09f942-27c6-4a99-915d-c0e699c194b6":
    "Scalable AI framework supporting segmentation and keypoint detection",
  "bcf7b75f-c172-40b2-9ee6-c3e548f0e3de":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "3a0b932f-ee2f-4ef7-97f0-c8a57779ce5d":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "7ab9ca1d-f2db-4ce9-ae63-d5b84ad7c265":
    "Developed by University of Freiburg, this model comes pretrained on ISBI Challenge dataset",
  "647399c4-a9b1-464d-afd7-d91a0659d428":
    "Developed by University of Freiburg, this model comes pretrained on ISBI Challenge dataset",
  "3a0f5d3a-5581-42a6-9680-dba81576e4e1":
    "Fast, lightweight model with real-time object detection",
  "d83b1ac9-b5cd-47cf-b26b-e1d3a367eb19":
    "Developed by Google Research, this model comes pretrained on ImageNet-1K dataset.",
  "8450710f-4902-49cf-9913-e566793e258d":
    "Transformer-based model with NMS-free training for better detection",
  "3393c36b-3052-4d1d-9de8-e6dd9a125b3a":
    "Developed by Ultralytics, this model comes pretrained on the COCO dataset",
  "4c8ddede-54bf-4adc-aeb4-6f3dea910193":
    "Developed by Alibaba DAMO Academy, this model comes pretrained on coco dataset.",
  "4c8ddede-54bf-4adc-aeb4-6f3dea910195":
    "license: MIT, Developed by: MultimediaTechLab, Weights trained on: COCO",
  "4c8ddede-54bf-4adc-aeb4-6f3dea910194":
    "license: MIT, Developed by: MultimediaTechLab, Weights trained on: COCO",
};

const CARD_HEIGHT = 565; // Fixed height per card
let SCROLL_DELAY = 100; // Prevents multiple triggers

const Train: React.FC<ImageGalleryProps> = ({ id, isTrainer }) => {
  // Ref to store previous status for selectedIndex

  const {
    labels,
    data,
    selectedIndex,
    setSelectedIndex,
    detailModels,
    modelsList,
    setModelsList,
    handleCheck,
    handleChange22,
    handleChange,
    dataIdDetails,
    setDataIdDetails,
    handleModelQuality,
    handleSubmit,
    handleDelete,
    handleRename,
    statusTrain,
    setStatusTrain,
    pendingDeleteId,
    isDeleteModalOpen,
    closeDeleteModal,
    confirmDelete,
    isDeleting,
    isSubmitting,
    setIsSubmitting,
  } = useTrain();

  const { projectDetails, setProjectDetails } = useProjects();
  const [currentConfusisonMetrixPNG, setCurrentConfusisonMetrixPNG] =
    useState(ConfusisonMetrixPNG);
  const [currentResultPNG, setCurrentResultPNG] = useState(ResultPNG);
  const [currentPCurvePNG, setCurrentPCurvePNG] = useState(PCurvePNG);
  const [currentSCurvePNG, setCurrentSCurvePNG] = useState(PCurvePNG);
  const [currentRCurvePNG, setCurrentRCurvePNG] = useState(RCurvePNG);
  const [currentKpisPNG, setCurrentKpisPNG] = useState(""); // Add for KPIs
  const [currentLabelsPNG, setCurrentLabelsPNG] = useState(""); // Add for Labels
  const [statusCMImg, setStatusCMImg] = useState<boolean | null>(null);
  const [statusRImg, setStatusRImg] = useState<boolean | null>(null);
  const [statusPCImg, setStatusPCImg] = useState<boolean | null>(null);
  const [statusRCImg, setStatusRCImg] = useState<boolean | null>(null);
  const [statusSCImg, setStatusSCImg] = useState<boolean | null>(null);
  const [trainValidate, setTrainValidate] = useState<boolean>(false);
  const [statusKpisImg, setStatusKpisImg] = useState<boolean | null>(null); // Add for KPIs
  const [statusLabelsImg, setStatusLabelsImg] = useState<boolean | null>(null); // Add for Labels

  const [loadingsd, setLoading] = useState<Boolean>(true);
  const dispatch: AppDispatch = useDispatch();
  const [spinnerLoads, setSpinnerLoads] = useState<Boolean>(true);

  const [updatedModelsList, setUpdatedModelsList] = useState<ProjectTrain[]>(
    []
  );
  const [currentStatus, setCurrentStatus] = useState<string>("");
  const [downloadingIds, setDownloadingIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { labelCount } = useSelector((state: RootState) => state.projectTrain);
  const [activeDropdownId, setActiveDropdownId] = useState<any>(null); // Track active dropdown
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const [localStores, setLocalStores] = useState<{ isTrainer: boolean }>({
    isTrainer: false,
  });
  const [hitf, setHitf] = useState<boolean>(false);

  const [sorted, setSorted] = useState<LabelCount[]>([]);
  const [renames, setRenames] = useState(false);
  const [modelType, setModelType] = useState<string | null>(null);
  const [modelName, setModelName] = useState("");
  const [project, setProject] = useState<Project>({
    id: "",
    labels: 0,
    images: 0,
    annotations: 0,
    models: 0,
    imageUrl: "",
    thubmImageUrl: "",
    name: "",
    description: "",
    taskTypeId: "",
    domainTypeId: "",
    createdDate: "",
    customerId: "",
    liked: false,
    annotatedImageCount: 0,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const boxRef = useRef(null);
  const stickyRef = useRef(null);
  const sentinelRef = useRef(null);
  const [isSticky, setIsSticky] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // If the sentinel is NOT visible, sticky box is at the top
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: [0] }
    );
    console.log(isSticky);

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) observer.unobserve(sentinelRef.current);
    };
  }, []);

  const toggleDropdown = (event: any, id: any) => {
    event.stopPropagation();
    setActiveDropdownId((prevId: any) => (prevId === id ? null : id));
  };

  // Helper to generate DownloadCMReport URL
  // Helper to generate DownloadCMReport URL and check if image exists
  function getDownloadCMReportUrl(
    trainingId: string,
    imgName: string,
    setStatusFn?: (exists: boolean) => void
  ): string {
    const url = `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${trainingId}&imgName=${imgName}`;
    // If the URL contains "Image does not exist", set status to false and return empty string
    if (url.includes("Image does not exist")) {
      if (setStatusFn) setStatusFn(false);
      return "";
    }
    if (setStatusFn) setStatusFn(true);
    return url;
  }

  const handleParentClick = () => {
    setActiveDropdownId(null);
  };

  const prevStatusRef = useRef<string | undefined>(undefined);

  // State for LivePlot URLs
  const [livePlot1Url, setLivePlot1Url] = useState<string>("");
  const [livePlot2Url, setLivePlot2Url] = useState<string>("");

  useEffect(() => {
    // Always update prevStatusRef to the current status for the selected index
    const selectedModel = modelsList.find(
      (model: any) =>
        model.id === selectedIndex || model.trainingId === selectedIndex
    );
    prevStatusRef.current = selectedModel?.status;
  }, [modelsList, selectedIndex]);

  useEffect(() => {
    if (!Array.isArray(modelsList) || selectedIndex === undefined) return;
    const train_id = selectedIndex;
    setCurrentConfusisonMetrixPNG(LoaderGIF);
    setCurrentResultPNG(LoaderGIF);
    setCurrentPCurvePNG(LoaderGIF);
    setCurrentRCurvePNG(LoaderGIF);
    setStatusCMImg(null);
    setStatusRImg(null);
    setStatusPCImg(null);
    setStatusRCImg(null);
    setStatusSCImg(null);
    // Always update all PNG states to force rerender, even if values are the same
    setCurrentConfusisonMetrixPNG(
      getDownloadCMReportUrl(
        train_id,
        "confusion_matrix.html",
        setStatusCMImg
      ) + `?t=${Date.now()}`
    );
    setCurrentResultPNG(
      getDownloadCMReportUrl(
        train_id,
        "results_comparison.webp",
        setStatusRImg
      ) + `?t=${Date.now()}`
    );
    setCurrentPCurvePNG(
      getDownloadCMReportUrl(train_id, "graph_1.html", setStatusPCImg) +
        `?t=${Date.now()}`
    );
    setCurrentSCurvePNG(
      getDownloadCMReportUrl(train_id, "samples.webp", setStatusSCImg) +
        `?t=${Date.now()}`
    );
    setCurrentRCurvePNG(
      getDownloadCMReportUrl(train_id, "graph_2.html", setStatusRCImg) +
        `?t=${Date.now()}`
    );
    setCurrentKpisPNG(
      getDownloadCMReportUrl(
        train_id,
        "train_page_kpis.html",
        setStatusKpisImg
      ) + `?t=${Date.now()}`
    );
    setCurrentLabelsPNG(
      getDownloadCMReportUrl(train_id, "labels.html", setStatusLabelsImg) +
        `?t=${Date.now()}`
    );
    setStatusSCImg(true);
    setStatusCMImg(true);
    setStatusRImg(true);
    setStatusPCImg(true);
    setStatusRCImg(true);

    // Set LivePlot URLs
    setLivePlot1Url(
      `${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot1?TrainingId=${train_id}`
    );
    setLivePlot2Url(
      `${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot2?TrainingId=${train_id}`
    );
    setCurrentStatus(prevStatusRef.current || "new");
  }, [prevStatusRef.current]);

  const maxModelLimit = parseInt(localStorage.getItem("maxModelLimit") ?? "0");
  const [maxModelCount, setMaxModelCount] = React.useState(false);
  const handleMaxModelCountClose = () => {
    setMaxModelCount(false);
  };
  const addNewModel = () => {
    if (maxModelLimit <= modelsList.length) {
      setMaxModelCount(true);
      return;
    } else {
      setMaxModelCount(false);
    }
    const hasLeadingZero = modelsList.some((model) =>
      model.trainingId?.startsWith("0.")
    );

    if (!hasLeadingZero) {
      const versionRegex = new RegExp(`Model_${project.name}_V(\\d+)$`);

      // Combine modelsList and updatedModelsList for checking
      const combinedModelsList = [...modelsList, ...(updatedModelsList || [])];

      // Find all models matching the project name
      const matchingModels = combinedModelsList.filter((model) =>
        model.name.match(versionRegex)
      );

      // Determine the highest version number
      const maxVersion = matchingModels.reduce((max, model) => {
        const match = model.name.match(versionRegex);
        if (match) {
          const version = parseInt(match[1], 10);
          return Math.max(max, version);
        }
        return max;
      }, 0);

      // Trim project name to ensure max length of 50 characters
      const maxAllowedProjectNameLength = 50 - `_V${maxVersion + 1}`.length - 6; // 6 accounts for "Model_" prefix
      const trimmedProjectName =
        project.name.length > maxAllowedProjectNameLength
          ? project.name.slice(0, maxAllowedProjectNameLength)
          : project.name;

      // Create a new model with the incremented version
      const newModel = {
        id: `0.${Date.now()}`, // Generate unique ID
        trainingId: `0.${Date.now()}`,
        name: `Model_${trimmedProjectName}_V${maxVersion + 1}`,
        progress: 0, // Example default
        status: "new", // Status based on presence of existing versions
      };

      setModelsList((prev) => [newModel, ...prev]);
      setSelectedIndex(newModel.id);
    }
  };

  // useEffect(() => {
  //   if (labelCount.length) {
  //     const sorteds = [...labelCount].sort((a, b) => b.count - a.count);
  //     setSorted(sorteds);
  //   }
  // }, [labelCount]);
  useEffect(() => {
    if (labelCount.length) {
      setSorted([...labelCount]);
    }
  }, [labelCount]);

  const augmentationOptions = [
    { name: "horizontalFlip", label: "Horizontal Flip" },
    { name: "verticalFlip", label: "Vertical Flip" },
    { name: "randomRotate", label: "Random Rotate" },
    { name: "randomCrop", label: "Random Crop" },
    { name: "randomShear", label: "Random Shear" },
    { name: "randomScale", label: "Random Scale" },
    { name: "resize", label: "Resize" },
    { name: "randomRotate90", label: "Random Rotate 90" },
    { name: "randomBrightnessContrast", label: "Random Brightness Contrast" },
    { name: "gaussNoise", label: "Gauss Noise" },
    { name: "hueSaturationValue", label: "Hue Saturation Value" },
    { name: "blur", label: "Blur" },
    { name: "equalize", label: "Equalize" },
    { name: "randomGamma", label: "Random Gamma" },
    { name: "sharpen", label: "Sharpen" },
    { name: "toGray", label: "To Gray" },
    { name: "toSepia", label: "To Sepia" },
    { name: "shiftScaleRotate", label: "Shift Scale Rotate" },
    { name: "opticalDistortion", label: "Optical Distortion" },
    { name: "gridDistortion", label: "Grid Distortion" },
    { name: "transpose", label: "Transpose" },
    { name: "solarize", label: "Solarize" },
    { name: "posterize", label: "Posterize" },
    { name: "invert", label: "Invert Colors" },
  ];

  useEffect(() => {
    setHitf(false);
    setValidationErrors({});
    setSpinnerLoads(true);
    setTimeout(() => {
      setSpinnerLoads(false);
    }, 2000);
    if (selectedIndex && selectedIndex.startsWith("0.")) {
      //console.log("initValues", modelsList[0].name);
      setTimeout(() => {
        const ids = [
          "d8e87b18-61c5-43a3-b3e6-42564f40329a",
          "764059dd-0e19-4d3c-b950-4772e0d7e3d3",
          "4f895d1e-40a7-43ce-aa11-8661f0ca68d0",
          "8450710f-4902-49cf-9913-e566793e258d",
        ];

        const matchedId =
          detailModels.find((model) => ids.includes(model.id))?.id ||
          detailModels[0]?.id;
        // Update data object
        const updatedDataIdDetails = {
          ...initialDataIdDetails,
          name: modelsList[0]?.name,
          advanceSetting: {
            ...initialDataIdDetails.advanceSetting,
            modelTypeId: matchedId,
          },
        };

        setDataIdDetails(updatedDataIdDetails);
      }, 500);
    } else {
      //console.log("initValues", dataIdDetails);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (hitf) {
      checkValidations();
    }
  }, [dataIdDetails]);

  const checkValidations = () => {
    // Initialize an object to store validation error messages
    const validationErrors: { [key: string]: string } = {};

    // Validate name: Minimum 3 characters

    if (dataIdDetails.name.length < 3) {
      validationErrors.name = "Name must be at least 3 characters long.";
    }

    // Validate modelTypeId: Should not be empty

    if (dataIdDetails.advanceSetting.modelTypeId === "") {
      validationErrors.modelTypeId = "Select a Model";
    }

    // Validate description: Minimum 1 character

    /*     if (dataIdDetails.description.length < 1) {
      validationErrors.description =
        "Description must have at least 1 character.";
    } */

    // Check if dataset split adds up to 1 (this check can be added based on your logic)

    // If there are any validation errors
    if (Object.keys(validationErrors).length > 0) {
      setValidationErrors(validationErrors); // Store the errors in state
    } else {
      setValidationErrors({}); // Clear any previous errors
    }
  };
  const handleRenameClose = () => {
    setRenames(false);
    localStorage.setItem("popupOpen", false.toString());
    // if (modelName !== undefined) {
    //   setDataIdDetails({ ...dataIdDetails, name: modelName });
    // }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchProjectTrainAll(id));
    }, 5000); // Poll every 5 seconds
    if (id) {
      clearModelData();
      dispatch(fetchProjectById(id))
        .then((response) => {
          setProject(response?.payload);
          // console.log("Fetch Project Success:", response?.payload); // Log response here on success
        })
        .catch((error) => {
          console.error("Fetch Project Failed:", error); // Log error on failure
        });
      dispatch(fetchTrainValidation(id)).then((response) => {
        if (response.payload) {
          // Set trainValidate true if isTrainer is true or remainCount > 0
          if (
            response.payload.isProjectOwner === true ||
            response.payload.isTrainer === true
          ) {
            setLocalStores((prev) =>
              prev ? { ...localStores, isTrainer: true } : prev
            );
          }
          if (
            response.payload.isProjectOwner === true ||
            response.payload.remainCount > 0
          ) {
            setTrainValidate(true);
          } else {
            setTrainValidate(false);
          }
        }
      });
      dispatch(fetchProjectTrainAll(id));
    }
    dispatch(fetchLabelCount(id));
    dispatch(fetchProjects())
      .unwrap()
      .then((result) => {
        // Assuming `result` is an array and you're looking for an object with a specific `id`
        const project = result.find((item: any) => item.id === id);

        if (project) {
          setProjectDetails(project);
          setLoading(false);
        }
      });
    dispatch(fetchModels(id));

    if (modelsList.length > 0 && modelsList[0].trainingId?.startsWith("0.")) {
      setModelsList((prev) => prev.filter((_, index) => index !== 0));
    }

    return () => {
      clearInterval(interval);
      setSelectedIndex(undefined);
    }; // Cleanup on unmount

    return () => setHitf(false);
  }, []);

  const getTooltipById = (id: string): string => {
    // Convert the input ID to lowercase to match the keys in the tooltips object
    const lowercaseId = id.toLowerCase();

    // Return the tooltip if the ID exists, otherwise return a default message
    return tooltips[lowercaseId] || "No tooltip found for the given ID.";
  };

  const handleSelect = (data: any) => {
    setCurrentConfusisonMetrixPNG(LoaderGIF);
    setCurrentResultPNG(LoaderGIF);
    setCurrentPCurvePNG(LoaderGIF);
    setCurrentRCurvePNG(LoaderGIF);
    setStatusCMImg(null);
    setStatusRImg(null);
    setStatusPCImg(null);
    setStatusRCImg(null);
    setStatusSCImg(null);
    const train_id = data; // remove once API is ready to get the dynamic id use trainingId: data once ready!
    // dispatch(
    //   fetchConfusionMatrix({
    //     trainingId: train_id,
    //     imageType: "confusion_matrix.html",
    //   })
    // )
    //   .unwrap()
    //   .then((result) => {
    //     setCurrentConfusisonMetrixPNG(result);
    //     if (result == "Image does not exist") {
    //       setStatusCMImg(false);
    //     } else {
    //       setStatusCMImg(true);
    //     }
    //     console.log("Confusion Matrix result:", result);
    //   })
    //   .catch((error) => {
    //     setStatusCMImg(false);
    //     console.error("Error fetching Confusion Matrix:", error);
    //   });

    setCurrentConfusisonMetrixPNG(
      getDownloadCMReportUrl(
        train_id,
        "confusion_matrix.html",
        setStatusCMImg
      ) + `?t=${Date.now()}`
    );
    setCurrentResultPNG(
      getDownloadCMReportUrl(
        train_id,
        "results_comparison.webp",
        setStatusRImg
      ) + `?t=${Date.now()}`
    );
    setCurrentPCurvePNG(
      getDownloadCMReportUrl(train_id, "graph_1.html", setStatusPCImg) +
        `?t=${Date.now()}`
    );
    setCurrentSCurvePNG(
      getDownloadCMReportUrl(train_id, "samples.webp", setStatusSCImg) +
        `?t=${Date.now()}`
    );
    setCurrentRCurvePNG(
      getDownloadCMReportUrl(train_id, "graph_2.html", setStatusRCImg) +
        `?t=${Date.now()}`
    );

    // Add new states for train_page_kpis.html and labels.html
    setCurrentKpisPNG(
      getDownloadCMReportUrl(
        train_id,
        "train_page_kpis.html",
        setStatusKpisImg
      ) + `?t=${Date.now()}`
    );
    setCurrentLabelsPNG(
      getDownloadCMReportUrl(train_id, "labels.html", setStatusLabelsImg) +
        `?t=${Date.now()}`
    );
    setStatusSCImg(true);
    setStatusCMImg(true);
    setStatusRImg(true);
    setStatusPCImg(true);
    setStatusRCImg(true);
    // dispatch(
    //   fetchConfusionMatrix({ trainingId: train_id, imageType: "graph_1.html" })
    // )
    //   .unwrap()
    //   .then((result) => {
    //     setCurrentResultPNG(result);
    //     if (result == "Image does not exist") {
    //       setStatusRImg(false);
    //     } else {
    //       setStatusRImg(true);
    //     }
    //     console.log("Confusion Matrix result:", result);
    //   })
    //   .catch((error) => {
    //     setStatusRImg(false);
    //     console.error("Error fetching Confusion Matrix:", error);
    //   });
    // dispatch(
    //   fetchConfusionMatrix({ trainingId: train_id, imageType: "graph_2.html" })
    // )
    //   .unwrap()
    //   .then((result) => {
    //     setCurrentPCurvePNG(result);
    //     if (result == "Image does not exist") {
    //       setStatusPCImg(false);
    //     } else {
    //       setStatusPCImg(true);
    //     }
    //     console.log("Confusion Matrix result:", result);
    //   })
    //   .catch((error) => {
    //     setStatusPCImg(false);
    //     console.error("Error fetching Confusion Matrix:", error);
    //   });
    // dispatch(
    //   fetchConfusionMatrix({ trainingId: train_id, imageType: "results_comparison.png" })
    // )
    //   .unwrap()
    //   .then((result) => {
    //     setCurrentRCurvePNG(result);
    //     if (result == "Image does not exist") {
    //       setStatusRCImg(false);
    //     } else {
    //       setStatusRCImg(true);
    //     }
    //     console.log("Confusion Matrix result:", result);
    //   })
    //   .catch((error) => {
    //     setStatusRCImg(false);
    //     console.error("Error fetching Confusion Matrix:", error);
    //   });
    setSelectedIndex(data);
  };

  // const handleSubmitRename = () => {

  //   dispatch(updateProjectTrain({ id: dataIdDetails.id, data: dataIdDetails }))
  //     .unwrap()
  //     .then((response) => {
  //       toast.success("Model Name Updated");
  //       // handleRenameClose();
  //       setRenames(false);
  //     })
  //     .catch((error) => {
  //       toast.error("The name already exists. Please choose a different name.");
  //     });
  // };

  const handleSubmitRename = () => {
    if (modelName.length < 3) {
      setIsSubmitted(true);
      return;
    }

    // Create the updated data object
    const updatedData = {
      ...dataIdDetails,
      name: modelName,
    };

    dispatch(updateProjectTrain({ id: dataIdDetails.id, data: updatedData }))
      .unwrap()
      .then((response) => {
        setSpinnerLoads(true);
        setTimeout(() => {
          setSpinnerLoads(false);
        }, 2000);
        toast.success("Model Name Updated");
        setRenames(false);
        localStorage.setItem("popupOpen", false.toString());
        setIsSubmitted(false);
        // Update the original dataIdDetails if needed
        setDataIdDetails(updatedData);
      })
      .catch((error) => {
        toast.error("The name already exists. Please choose a different name.");
      });
  };

  //console.log(modelsList);
  useEffect(() => {
    if (!dataIdDetails?.id) return;
    if (statusTrain && Array.isArray(statusTrain)) {
      const isInUpdatedModelsList = updatedModelsList.some(
        (model) => model.id === dataIdDetails.id
      );

      const isInStatusTrain = statusTrain.some(
        (train) => train.trainingId === dataIdDetails.id
      );

      if (!isInUpdatedModelsList && !isInStatusTrain) {
        // setSelectedIndex(undefined);
      }
    }
  }, [updatedModelsList, dataIdDetails, statusTrain]);

  const options = ["ExtraSmall", "Small", "Medium", "Large", "ExtraLarge"];

  const isChecked = (value: any) =>
    dataIdDetails?.advanceSetting?.modelQuality === value;

  const isDisabled = () =>
    selectedIndex === undefined || dataIdDetails?.id !== "";

  const handleStop = async (trainingId: string) => {
    setIsLoading(true);
    setSpinnerLoads(true);
    try {
      // Dispatch removeTraining
      await dispatch(removeTraining(trainingId))
        .unwrap()
        .then(() => dispatch(fetchProjectTrainAll(id)));

      // If successful, show success message and update state

      toast.success("Training successfully stopped!");
      setSelectedIndex(undefined);
      if (id) {
        dispatch(fetchProjectTrainAll(id));
      }
    } catch (err: any) {
      // If an error occurs, set the error message
      // setError(err.message || "Failed to remove the training.");
      toast.error("Failed to remove the training!");
    } finally {
      // Stop the loader
      setIsLoading(false);
      setSelectedIndex(undefined);
      setDataIdDetails({ ...dataIdDetails, id: "" });
    }
  };

  const handleDownload = async (trainingId: string) => {
    if (!trainingId) {
      // Handle the case where the trainingId is null (optional)
      console.error("No trainingId provided!");
      return;
    }

    setDownloadingIds((prev) => [...prev, trainingId]); // Add the new ID to the array

    const resultAction = await dispatch(
      downloadTest({
        trainingId,
        options: {
          onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
            // Specify the type here
            const total = progressEvent.total || 0;
            const current = progressEvent.loaded || 0;
            const percentage = Math.floor((current / total) * 100);
          },
        },
      })
    );

    // Remove ID from downloadingIds once the download completes
    setDownloadingIds((prev) => prev.filter((id) => id !== trainingId));

    if (downloadTest.fulfilled.match(resultAction)) {
      toast.success(`Download completed`, {
        position: "bottom-right",
      });
    } else {
      toast.error(resultAction.error.message as string, {
        position: "bottom-right",
      });
    }
  };

  const handlePublish = () => {
    dispatch(publishModel(dataIdDetails.id))
      .unwrap()
      .then((response) => {
        toast.success("Model Published Successfully");
        setDataIdDetails({ ...dataIdDetails, isPublished: true });
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const [openConfusionMatrix, setOpenConfusionMatrix] = useState(false);
  const handleOpenConfusionMatrix = () => {
    setOpenConfusionMatrix(true);
  };
  const handleCloseConfusionMatrix = () => {
    setOpenConfusionMatrix(false);
  };

  const sectionsRef = useRef<(HTMLDivElement | null)[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isScrolling = useRef(false);

  const scrollToSection = (index: number) => {
    if (sectionsRef.current[index]) {
      sectionsRef.current[index]!.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };

  const handleWheel = (event: React.WheelEvent) => {
    event.preventDefault();

    const deltaY = Math.abs(event.deltaY);
    const deltaX = Math.abs(event.deltaX);

    if (deltaY > 0) {
      if (deltaY > 50) {
        SCROLL_DELAY = 100;
        //  console.log("Mouse Wheel Scroll Detected 🖱️");
      } else {
        SCROLL_DELAY = 500;
        //  console.log("Touchpad Scroll Detected 🎚️");
      }
    }

    if (isScrolling.current) return;

    isScrolling.current = true; // Lock scrolling

    setCurrentIndex((prevIndex) => {
      let newIndex = prevIndex + (event.deltaY > 0 ? 1 : -1);
      newIndex = Math.max(
        0,
        Math.min(newIndex, sectionsRef.current.length - 1)
      );

      scrollToSection(newIndex);

      setTimeout(() => {
        isScrolling.current = false; // Unlock scrolling after delay
      }, SCROLL_DELAY);

      return newIndex;
    });
  };

  const handleRedirectPlanPage = () => {
    const customerId = localStorage.getItem("customerId");
    window.open(
      `https://saas.unifynow.ai/price/plan?id=${customerId}_Vision_StudioPlans`,
      "_blank"
    );
  };

  return (
    <>
      <div onClick={handleParentClick}>
        {loadingsd ? (
          <Box>
            <VisionStudioSpinner />
            <Typography
              sx={{
                justifyContent: "center",
                verticalAlign: "middle",
                position: "fixed",
                height: "calc(100vh - 100px)",
                alignContent: "center",
                marginTop: "50px",
                textAlign: "center",
                width: "calc(100vw - 60px)",
                fontWeight: "500",
              }}
            >
              Initializing Training servers
            </Typography>
          </Box>
        ) : projectDetails.annotations ? (
          <>
            <Box
              padding="8px 10px 0 13px"
              sx={{
                display: "flex",
                gap: "6px",
                position: "fixed",
                width: "calc(100vw - 100px)",
              }}
            >
              <Box
                sx={{
                  flex: "0 0 22%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Card sx={{ boxShadow: "none" }}>
                    <CardContent sx={{ paddingBottom: "0" }}>
                      <Typography
                        sx={{
                          color: "#1F4690",
                          fontSize: "22px",
                          fontWeight: "400",
                          paddingBottom: "0",
                        }}
                      >
                        Get Started by Building a new Model
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <ResponsiveTooltip
                        title={
                          !trainValidate
                            ? "You do not have permission to create a new model"
                            : !project.annotatedImageCount ||
                              project.annotatedImageCount < 10
                            ? "Minimum 10 images should be annotated to Enable this feature"
                            : "A create section is already open"
                        }
                        disableHoverListener={
                          !!(
                            trainValidate &&
                            (!modelsList.length ||
                              !modelsList[0].trainingId?.startsWith("0.")) &&
                            project.annotatedImageCount &&
                            project.annotatedImageCount >= 10
                          )
                        }
                      >
                        <span style={{ display: "inline-block" }}>
                          <Button
                            id="createNewModel"
                            size="small"
                            variant="contained"
                            sx={{
                              padding: "9px",
                              fontWeight: "600",
                              textTransform: "capitalize",
                              background:
                                !trainValidate ||
                                (modelsList.length &&
                                  modelsList[0].trainingId?.startsWith("0.")) ||
                                !project.annotatedImageCount ||
                                project.annotatedImageCount < 10
                                  ? "#666"
                                  : "",
                              "&:hover": {
                                background:
                                  !trainValidate ||
                                  (modelsList.length &&
                                    modelsList[0].trainingId?.startsWith(
                                      "0."
                                    )) ||
                                  !project.annotatedImageCount ||
                                  project.annotatedImageCount < 10
                                    ? "#555"
                                    : "",
                                cursor:
                                  !trainValidate ||
                                  (modelsList.length &&
                                    modelsList[0].trainingId?.startsWith(
                                      "0."
                                    )) ||
                                  !project.annotatedImageCount ||
                                  project.annotatedImageCount < 10
                                    ? "not-allowed"
                                    : "",
                              },
                            }}
                            disabled={false}
                            onClick={() => {
                              if (
                                !trainValidate ||
                                (modelsList.length &&
                                  modelsList[0].trainingId?.startsWith("0.")) ||
                                !project.annotatedImageCount ||
                                project.annotatedImageCount < 10
                              ) {
                                return;
                              }
                              addNewModel();
                            }}
                          >
                            Create New Model +
                          </Button>
                        </span>
                      </ResponsiveTooltip>
                    </CardActions>
                  </Card>
                </Box>
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    marginTop: "15px",
                    flexGrow: "1",
                  }}
                >
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "",
                        padding: "5px 10px",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{ fontSize: "16px", color: "#666666" }}
                      >
                        Trained models
                      </Typography>
                      {/* <Button sx={{ background: "#F1F1F2" }}>
                    <FilterAltOutlined sx={{ color: "black" }} />
                  </Button> */}
                    </Box>
                    <Box>
                      <List
                        id="listOfModels"
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          overflow: "scroll",
                          height: "calc(100vh - 339px)",
                        }}
                      >
                        {modelsList.length > 0 ? (
                          <>
                            {modelsList && modelsList.length > 0 ? (
                              modelsList.map((item, i) => (
                                <abbr
                                  title={item.name}
                                  style={{ textDecoration: "none" }}
                                >
                                  <ListItem
                                    sx={{
                                      padding: "8px",
                                      borderBottom: "1px solid #d3d3d3",
                                      borderTop:
                                        item && "progress" in item
                                          ? "2px solid transparent"
                                          : "none",
                                      background:
                                        item && "progress" in item
                                          ? `linear-gradient(to right, #cfeeff ${item.progress}%, transparent ${item.progress}%)`
                                          : "none",
                                      backgroundColor:
                                        selectedIndex === undefined
                                          ? "transparent"
                                          : selectedIndex === item.id ||
                                            selectedIndex === item.trainingId
                                          ? "#e0e0e0"
                                          : "transparent",
                                      "&:hover": {
                                        backgroundColor: "#e0e0e0",
                                        cursor: "pointer",
                                      },
                                      position: "relative", // Needed for positioning

                                      // Apply triangle and text only when status is "failed" or "cancelled"
                                      ...((item &&
                                        item?.status?.toLowerCase() ===
                                          "failed") ||
                                      item?.status?.toLowerCase() ===
                                        "cancelled"
                                        ? {
                                            "&::before": {
                                              content: '""',
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              width: 0,
                                              height: 0,
                                              borderLeft:
                                                "20px solid #FF000033",
                                              borderTop: "20px solid #FF000033",
                                              borderRight:
                                                "20px solid transparent",
                                              borderBottom:
                                                "20px solid transparent",
                                            },
                                            "&::after": {
                                              content: '"Fail"',
                                              position: "absolute",
                                              top: 5,
                                              left: 2,
                                              color: "#555555",
                                              fontSize: "10px",
                                              fontWeight: "bold",
                                              transform: "rotate(-45deg)",
                                            },
                                          }
                                        : {}),
                                    }}
                                    onClick={() => {
                                      const idToCheck = item.id
                                        ? item.id
                                        : item?.trainingId;
                                      if (idToCheck !== selectedIndex) {
                                        setDataIdDetails(initialDataIdDetails);
                                        handleSelect(idToCheck);
                                      }
                                    }}
                                  >
                                    <ListItemAvatar>
                                      <img
                                        src={trainModel}
                                        alt="model"
                                        style={{
                                          height: "40px",
                                          width: "40px",
                                        }}
                                      />
                                    </ListItemAvatar>

                                    <ListItemText
                                      sx={{ flex: "1 1 55%" }}
                                      primary={
                                        item.name.length > 20
                                          ? item.name.substring(0, 20) + "..."
                                          : item.name
                                      }
                                      secondary={
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              margin: "0",
                                            }}
                                          >
                                            Dataset:
                                            <span>
                                              {item.imageCount
                                                ? item.imageCount
                                                : "00"}
                                            </span>
                                            <span style={{ margin: "0 5px" }}>
                                              |
                                            </span>
                                          </p>
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              margin: "0",
                                            }}
                                          >
                                            Labels:
                                            <span>
                                              {item.labelCount
                                                ? item.labelCount
                                                : "00"}
                                            </span>
                                            <span style={{ margin: "0 5px" }}>
                                              |
                                            </span>
                                          </p>
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              margin: "0",
                                            }}
                                          >
                                            Model Size:
                                            {item.id?.startsWith("0.") ? (
                                              <span style={{ color: "red" }}>
                                                untrained
                                              </span>
                                            ) : (
                                              <span>
                                                {item.modelSize != null
                                                  ? `${Number(
                                                      item.modelSize
                                                    ).toFixed(2)} MB`
                                                  : "0.00 MB"}
                                              </span>
                                            )}
                                          </p>
                                        </Box>
                                      }
                                    />

                                    <div
                                      key={i}
                                      style={{
                                        alignSelf: "self-start",
                                        textAlign: "end",
                                        fontSize: "12px",
                                        position: "relative", // Necessary for dropdown positioning
                                      }}
                                    >
                                      {(item as {
                                        status?: string;
                                        progress?: unknown;
                                      }) &&
                                        "status" in item &&
                                        "progress" in item &&
                                        typeof item.status === "string" &&
                                        (item.status.toLowerCase() ===
                                          "success" ||
                                          item.status.toLowerCase() ===
                                            "pending" ||
                                          item.status.toLowerCase() ===
                                            "commencing") && (
                                          <div className="loader">
                                            <div className="bar"></div>
                                            <div className="bar"></div>
                                            <div className="bar"></div>
                                          </div>
                                        )}

                                      {(item as {
                                        status?: string;
                                        progress?: unknown;
                                      }) &&
                                        "status" in item &&
                                        "progress" in item &&
                                        typeof item.status === "string" &&
                                        item.status.toLowerCase() ===
                                          "running" && (
                                          <Box
                                            position="relative"
                                            display="inline-flex"
                                          >
                                            <CircularProgress
                                              variant="determinate"
                                              value={100}
                                              size={40} // Reduce size
                                              thickness={5} // Adjust thickness if needed
                                            />
                                            <Box
                                              top={0}
                                              left={0}
                                              bottom={0}
                                              right={0}
                                              position="absolute"
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="center"
                                            >
                                              <Typography
                                                variant="caption"
                                                component="div"
                                                fontSize="0.6rem" // Make text smaller
                                                color="textSecondary"
                                                fontWeight={700} // Increased font weight
                                              >
                                                <b>{`${Math.round(
                                                  typeof item.progress ===
                                                    "number"
                                                    ? item.progress
                                                    : 0
                                                )}%`}</b>
                                              </Typography>
                                            </Box>
                                          </Box>
                                        )}

                                      {"status" in item &&
                                        "progress" in item &&
                                        typeof item.status === "string" &&
                                        (item.status.toLowerCase() ===
                                          "cancelled" ||
                                          item.status.toLowerCase() ===
                                            "failed" ||
                                          item.status.toLowerCase() ===
                                            "completed") &&
                                        localStores?.isTrainer && (
                                          <MoreHorizIcon
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleDropdown(e, item.id); // Pass the clicked item's id
                                            }}
                                          />
                                        )}

                                      {activeDropdownId === item.id && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            right: 0,
                                            top: "60%", // Position below the button
                                            background: "#fff",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            textAlign: "start",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                            zIndex: 10,
                                          }}
                                        >
                                          <div
                                            style={{
                                              padding: "8px 12px",
                                              cursor: "pointer",
                                            }}
                                            className="dele"
                                            onClick={() => {
                                              handleDelete(item.id);
                                              setActiveDropdownId(null);
                                            }}
                                          >
                                            Delete
                                          </div>
                                          {item.status?.toLowerCase() ===
                                          "completed" ? (
                                            <div
                                              style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                              }}
                                              className="edi"
                                              onClick={() => {
                                                setIsSubmitted(false);
                                                handleRename(item.id);
                                                setRenames(true);
                                                localStorage.setItem(
                                                  "popupOpen",
                                                  true.toString()
                                                );
                                                setModelName(item.name);
                                                setActiveDropdownId(null);
                                              }}
                                            >
                                              Rename
                                            </div>
                                          ) : null}
                                        </div>
                                      )}
                                    </div>
                                  </ListItem>
                                </abbr>
                              ))
                            ) : (
                              <MenuItem disabled>No models available</MenuItem>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </List>
                    </Box>
                  </>
                </Box>
              </Box>
              {selectedIndex &&
              !selectedIndex.startsWith("0.") &&
              modelsList.some((model) => model.id === selectedIndex) ? (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      height: "calc(100vh - 117px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {currentStatus.toLocaleLowerCase() === "success" ? (
                      <>
                        {" "}
                        <Box
                          sx={{
                            background: "white",
                            // marginTop: "15px",
                            borderRadius: "5px",
                            padding: "15px 15px 5px 15px",
                            height: "119px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "20px" }}>
                            <Card
                              sx={{
                                flex: "0 0 25%",
                                padding: "13px",
                                marginBottom: "15px",
                                background: "#F5F6F9",
                                height: "100%",
                              }}
                            >
                              <CardHeader
                                sx={{ padding: "0" }}
                                avatar={
                                  <Avatar
                                    aria-label="recipe"
                                    alt="Person 2"
                                    src={totalImages}
                                    sx={{
                                      width: 30,
                                      height: 30,
                                      marginRight: "-6px",
                                      borderRadius: "0",
                                    }}
                                  ></Avatar>
                                }
                                action={
                                  <IconButton aria-label="settings">
                                    {/* <KeyboardArrowDownIcon /> */}
                                  </IconButton>
                                }
                              />
                              <CardContent
                                sx={{
                                  padding: "0",
                                  paddingBottom: "0!important",
                                }}
                              >
                                <Typography
                                  gutterBottom
                                  variant="h5"
                                  component="div"
                                  sx={{
                                    color: "#45464E",
                                    fontSize: "15px",
                                    marginTop: "7px",
                                  }}
                                >
                                  Total Images
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#A1AEBE", fontSize: "16px" }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#A1AEBE",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {projectDetails.images}
                                  </Typography>
                                </Typography>
                              </CardContent>
                            </Card>
                            <Card
                              sx={{
                                flex: "0 0 25%",
                                padding: "13px",
                                background: "#F5F6F9",
                                height: "100%",
                              }}
                            >
                              <CardHeader
                                sx={{ padding: "0" }}
                                avatar={
                                  <Avatar
                                    aria-label="recipe"
                                    alt="Person 2"
                                    src={datasetIcon}
                                    sx={{
                                      width: 30,
                                      height: 30,
                                      marginRight: "-6px",
                                      borderRadius: "0",
                                    }}
                                  ></Avatar>
                                }
                                action={
                                  <IconButton aria-label="settings">
                                    {/* <KeyboardArrowDownIcon /> */}
                                  </IconButton>
                                }
                              />
                              <CardContent
                                sx={{
                                  padding: "0",
                                  paddingBottom: "0!important",
                                }}
                              >
                                <Typography
                                  gutterBottom
                                  variant="h5"
                                  component="div"
                                  sx={{
                                    color: "#45464E",
                                    fontSize: "15px",
                                    marginTop: "7px",
                                  }}
                                >
                                  Total Annotations
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#A1AEBE", fontSize: "16px" }}
                                >
                                  {projectDetails.annotations}
                                </Typography>
                              </CardContent>
                            </Card>
                            <div
                              id="presentStatus"
                              style={{
                                width: "100%",
                                overflowY: "scroll",
                                maxHeight: "119px",
                                minHeight: "119px",
                                borderRadius: "5px",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <Card
                                sx={{
                                  flex: "0 0 50%",
                                  padding: "3px 15px 0 15px",
                                  background: "#F5F6F9",
                                }}
                              >
                                <CardHeader sx={{ padding: "0" }} />
                                <CardContent
                                  sx={{
                                    padding: "0",
                                    paddingBottom: "0!important",
                                  }}
                                >
                                  <Typography sx={{ fontSize: "12px" }}>
                                    Present Status
                                  </Typography>
                                  <HorizontalBarChart
                                    data={sorted?.map((item) => item.count)} // Map to extract counts
                                    labels={sorted?.map(
                                      (item) => item.labelName
                                    )} // Map to extract label names
                                    labelColor={sorted?.map(
                                      (item) => item.labelColor
                                    )}
                                  />
                                </CardContent>
                              </Card>
                            </div>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ display: "flex", gap: "10px" }}>
                          <Box sx={{ flex: "0 0 50%" }}>
                            {/* <Card
                          sx={{
                            height: "179px",
                            overflow: "auto",
                            // padding: "10px !important",
                            background: "#FAFAFB",
                          }}
                        > */}
                            <CardContent
                              sx={{
                                padding: "0",
                                paddingBottom: "0 !important",
                              }}
                            >
                              {spinnerLoads ? (
                                <TrainPageSkeleton
                                  width="100%"
                                  height="179px"
                                />
                              ) : (
                                <ConfusionMatrixIframe
                                  src={currentKpisPNG.replace(/\?t=\d+$/, "")}
                                  height="179px"
                                  scrolling="yes"
                                  time={currentStatus}
                                />
                              )}
                            </CardContent>
                            {/* </Card> */}
                          </Box>
                          <Box sx={{ flex: "0 0 49.5%" }}>
                            <Card
                              sx={{
                                height: "179px",
                                overflow: "auto",
                                padding: "10px !important",
                                background: "#FAFAFB",
                                boxShadow: "none",
                              }}
                            >
                              {" "}
                              <CardContent
                                sx={{
                                  padding: "0",
                                  paddingBottom: "0 !important",
                                }}
                              >
                                {spinnerLoads ? (
                                  <TrainPageSkeleton
                                    width="100%"
                                    height="179px"
                                  />
                                ) : (
                                  <ConfusionMatrixIframe
                                    src={currentLabelsPNG.replace(
                                      /\?t=\d+$/,
                                      ""
                                    )}
                                    height="179px"
                                    scrolling="yes"
                                    time={currentStatus}
                                  />
                                )}
                              </CardContent>
                            </Card>
                          </Box>
                        </Box>
                      </>
                    )}

                    {spinnerLoads ? (
                      <TrainPageSkeleton width="100%" height="50px" />
                    ) : (
                      <>
                        <div ref={sentinelRef} style={{ height: "1px" }} />
                        <Box
                          ref={stickyRef}
                          sx={{
                            display: "flex",
                            gap: "20px",
                            position: "sticky",
                            top: "0",
                            background: "#FAFAFB",
                            padding: "10px 0 10px 0",
                            alignItems: "center",
                            marginTop: "15px",
                            zIndex: 1000,
                            justifyContent: "space-between",
                          }}
                        >
                          
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#1D1D51",
                                fontSize: "18px",
                                fontWeight: "400",
                                paddingLeft: "20px",
                              }}
                            >
                              {dataIdDetails?.name || ""}
                            </Typography>
                            &emsp;
                            {localStores?.isTrainer &&
                              (() => {
                                const model = modelsList.find(
                                  (model) => model.id === dataIdDetails.id
                                );
                                const status = model?.status?.toLowerCase();
                                if (status === "completed") {
                                  return dataIdDetails.isPublished ? (
                                    <Button
                                      id="trainDownloadModel"
                                      onClick={() => {
                                        const modelId = dataIdDetails?.id;
                                        if (modelId) {
                                          handleDownload(modelId);
                                        }
                                      }}
                                      variant="contained"
                                      sx={{
                                        background: "white",
                                        color: "#666666",
                                        "&:hover": {
                                          background: "white",
                                        },
                                        ...(downloadingIds.includes(
                                          dataIdDetails?.id || ""
                                        ) && {
                                          background:
                                            "linear-gradient(90deg, lightgreen, lightyellow)",
                                          backgroundSize: "200% 100%",
                                          animation:
                                            "slideBackground 3s ease-in-out infinite",
                                        }),
                                      }}
                                      className={
                                        downloadingIds.includes(
                                          dataIdDetails?.id || ""
                                        )
                                          ? "button-downloading"
                                          : ""
                                      }
                                      startIcon={
                                        <FileDownloadOutlined fontSize="small" />
                                      }
                                      disabled={downloadingIds.includes(
                                        dataIdDetails?.id || ""
                                      )}
                                    >
                                      {downloadingIds.includes(
                                        dataIdDetails?.id || ""
                                      )
                                        ? "Downloading"
                                        : "Download"}
                                    </Button>
                                  ) : (
                                    <>
                                      <Button
                                        variant="contained"
                                        onClick={handlePublish}
                                      >
                                        Publish
                                      </Button>
                                    </>
                                  );
                                } else if (
                                  status === "running" ||
                                  status === "pending" ||
                                  status === "commencing"
                                ) {
                                  return (
                                    <Button
                                      variant="contained"
                                      sx={{
                                        background: "white",
                                        color: "#666666",
                                        "&:hover": {
                                          background: "#F1F3F4",
                                        },
                                      }}
                                      onClick={() =>
                                        handleStop(dataIdDetails.id)
                                      }
                                    >
                                      <img
                                        src={startTrainingActive}
                                        alt=""
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          objectFit: "contain",
                                          cursor: "pointer",
                                          padding: "6px 0px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      &emsp;Stop Training
                                    </Button>
                                  );
                                } else {
                                  return null;
                                }
                              })()}
                          </div>
                        </Box>
                      </>
                    )}

                    <div>
                      {spinnerLoads ? (
                        <TrainPageSkeleton width={"100%"} height={"100%"} />
                      ) : (
                        <Box
                          sx={{
                            marginTop: "14px",

                            borderTopLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                            paddingBottom: "10px",
                            position: "relative",
                          }}
                        >
                          {(() => {
                            const model = modelsList.find(
                              (model: ProjectTrain) =>
                                model.id === dataIdDetails.id
                            ) as ProjectTrain | undefined;
                            const status = model?.status?.toLowerCase();

                            if (
                              status === "failed" ||
                              status === "cancelled" ||
                              status === "running" ||
                              status === "pending" ||
                              status === "commencing" ||
                              status === "success"
                            ) {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    width: "100%",
                                    overflow:
                                      status === "pending" ||
                                      status === "commencing" ||
                                      status === "cancelled" ||
                                      status === "failed"
                                        ? "hidden"
                                        : "auto",
                                  }}
                                >
                                  <Card
                                    sx={{
                                      padding: "0 20px 20px 20px",
                                      background: "#FAFAFB",
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        padding: "0",
                                        paddingBottom: "0 !important",
                                      }}
                                    >
                                      {(() => {
                                        if (
                                          status === "failed" ||
                                          status === "cancelled"
                                        ) {
                                          return (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "calc(100vh - 299px)",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  width: 150,
                                                  height: 150,
                                                  borderRadius: "50%",
                                                  backgroundColor: "red",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  position: "relative",
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: 80,
                                                    fontWeight: "bold",
                                                    color: "white",
                                                    animation:
                                                      "shake 0.4s ease-in-out infinite",
                                                    "@keyframes shake": {
                                                      "0%": {
                                                        transform:
                                                          "translateX(0)",
                                                      },
                                                      "25%": {
                                                        transform:
                                                          "translateX(-5px)",
                                                      },
                                                      "50%": {
                                                        transform:
                                                          "translateX(5px)",
                                                      },
                                                      "75%": {
                                                        transform:
                                                          "translateX(-5px)",
                                                      },
                                                      "100%": {
                                                        transform:
                                                          "translateX(0)",
                                                      },
                                                    },
                                                  }}
                                                >
                                                  !
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  textAlign: "center",
                                                  marginTop: 0,
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: "20px",
                                                    color: "#000000",
                                                    fontWeight: "600",
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  Training failed!
                                                </Typography>
                                                <span
                                                  style={{
                                                    color: "#0000003d",
                                                    fontSize: "15px",
                                                  }}
                                                >
                                                  Check errors & try again
                                                </span>
                                              </Box>
                                            </Box>
                                          );
                                        }

                                        if (
                                          status === "running" ||
                                          status === "pending" ||
                                          status === "commencing" ||
                                          status === "success"
                                        ) {
                                          return (
                                            <Box
                                              sx={{
                                                textAlign: "center",
                                                alignContent: "center",
                                              }}
                                            >
                                              <>
                                                {status === "running" ? (
                                                  <>
                                                    {dataIdDetails &&
                                                    Number(
                                                      dataIdDetails.progress
                                                    ) >= 90 ? (
                                                      <Box
                                                        sx={{
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                          alignContent:
                                                            "center",
                                                          flexWrap: "wrap",
                                                          height:
                                                            "calc(100vh - 299px)",
                                                          background: "#fff",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <video
                                                          height="60"
                                                          loop
                                                          autoPlay
                                                          muted
                                                        >
                                                          <source
                                                            src={dataProcess}
                                                            type="video/mp4"
                                                          />
                                                          Your browser does not
                                                          support the video tag.
                                                        </video>
                                                        <Box
                                                          sx={{ width: "100%" }}
                                                        >
                                                          <Typography
                                                            sx={{
                                                              fontSize: "20px",
                                                              color: "#000000",
                                                              fontWeight: "600",
                                                            }}
                                                          >
                                                            Data to Intelligence
                                                          </Typography>
                                                          <span
                                                            style={{
                                                              color:
                                                                "#0000003d",
                                                              fontSize: "15px",
                                                            }}
                                                          >
                                                            Complex algorithms
                                                            at work. Progress
                                                            looks good!
                                                          </span>
                                                        </Box>
                                                      </Box>
                                                    ) : (
                                                      <Box
                                                        sx={{
                                                          display: "grid",
                                                          gap: "10px",
                                                          gridTemplateColumns:
                                                            "repeat(1, 1fr)",
                                                          // paddingBottom:
                                                          //   "140px",
                                                        }}
                                                      >
                                                        <Card
                                                          sx={{
                                                            padding: "15px",
                                                            // background: "#FAFAFB",
                                                            boxShadow: "none",
                                                          }}
                                                        >
                                                          <CardContent
                                                            sx={{
                                                              padding: "0",
                                                              paddingBottom:
                                                                "0 !important",
                                                            }}
                                                          >
                                                            <iframe
                                                              src={`${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot1?TrainingId=${dataIdDetails.id}`}
                                                              height="456px"
                                                              width="100%"
                                                              scrolling="no"
                                                              style={{
                                                                border: "none",
                                                              }}
                                                            />
                                                          </CardContent>
                                                        </Card>

                                                        <Card
                                                          sx={{
                                                            padding: "15px",
                                                            // background: "#FAFAFB",
                                                            boxShadow: "none",
                                                          }}
                                                        >
                                                          <CardContent
                                                            sx={{
                                                              padding: "0",
                                                              paddingBottom:
                                                                "0 !important",
                                                            }}
                                                          >
                                                            <iframe
                                                              src={`${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot2?TrainingId=${dataIdDetails.id}`}
                                                              height="456px"
                                                              width="100%"
                                                              scrolling="no"
                                                              style={{
                                                                border: "none",
                                                              }}
                                                            />
                                                          </CardContent>
                                                        </Card>
                                                        <Card
                                                          sx={{
                                                            padding: "15px",
                                                            // background: "#FAFAFB",
                                                            boxShadow: "none",
                                                          }}
                                                        >
                                                          <CardContent
                                                            sx={{
                                                              padding: "0",
                                                              paddingBottom:
                                                                "0 !important",
                                                            }}
                                                          >
                                                            <AuthenticatedReportImage
                                                              src={currentSCurvePNG.replace(
                                                                /\?t=\d+$/,
                                                                ""
                                                              )}
                                                              height="456px"
                                                              width="100%"
                                                            />
                                                          </CardContent>
                                                        </Card>
                                                      </Box>
                                                    )}
                                                  </>
                                                ) : status === "success" ? (
                                                  <Box
                                                    sx={{
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      alignContent: "center",
                                                      flexWrap: "wrap",
                                                      height:
                                                        "calc(100vh - 299px)",
                                                      background: "#fff",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <video
                                                      height="80"
                                                      loop
                                                      autoPlay
                                                      muted
                                                    >
                                                      <source
                                                        src={crunching}
                                                        type="video/mp4"
                                                      />
                                                      Your browser does not
                                                      support the video tag.
                                                    </video>
                                                    <Box sx={{ width: "100%" }}>
                                                      <Typography
                                                        sx={{
                                                          fontSize: "20px",
                                                          color: "#000000",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        Crunching Data...
                                                      </Typography>
                                                      <span
                                                        style={{
                                                          color: "#0000003d",
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        Initializing the
                                                        training process. Let’s
                                                        get those neurons
                                                        firing!
                                                      </span>
                                                    </Box>
                                                  </Box>
                                                ) : status === "commencing" ||
                                                  status === "pending" ? (
                                                  <Box
                                                    sx={{
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      alignContent: "center",
                                                      flexWrap: "wrap",
                                                      height:
                                                        "calc(100vh - 299px)",
                                                      background: "#fff",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <video
                                                      width="150"
                                                      loop
                                                      autoPlay
                                                      muted
                                                    >
                                                      <source
                                                        src={finalResult}
                                                        type="video/mp4"
                                                      />
                                                      Your browser does not
                                                      support the video tag.
                                                    </video>
                                                    <Box sx={{ width: "100%" }}>
                                                      <Typography
                                                        sx={{
                                                          fontSize: "20px",
                                                          color: "#000000",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        Final stretch
                                                      </Typography>
                                                      <span
                                                        style={{
                                                          color: "#0000003d",
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        Your AI has reached its
                                                        peak. Let’s take it
                                                        live!
                                                      </span>
                                                    </Box>
                                                  </Box>
                                                ) : (
                                                  "There is no result for this model."
                                                )}
                                              </>
                                            </Box>
                                          );
                                        }

                                        return null;
                                      })()}
                                    </CardContent>
                                  </Card>
                                </Box>
                              );
                            }

                            return null;
                          })()}

                          {(() => {
                            const model = modelsList.find(
                              (model: ProjectTrain) =>
                                model.id === dataIdDetails.id
                            ) as ProjectTrain | undefined;
                            const status = model?.status?.toLowerCase();

                            if (status === "completed") {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    width: "100%",
                                    // paddingBottom: "140px",
                                  }}
                                >
                                  <Card
                                    sx={{
                                      padding: "15px",
                                      // background: "#FAFAFB",
                                      boxShadow: "none",
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        padding: "0",
                                        paddingBottom: "0 !important",
                                      }}
                                    >
                                      {}
                                      <ConfusionMatrixIframe
                                        src={currentRCurvePNG.replace(
                                          /\?t=\d+$/,
                                          ""
                                        )}
                                        height="456px"
                                        scrolling="no"
                                        time={currentStatus}
                                      />
                                    </CardContent>
                                  </Card>
                                  <Card
                                    sx={{
                                      padding: "15px",
                                      // background: "#FAFAFB",
                                      boxShadow: "none",
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        padding: "0",
                                        paddingBottom: "0 !important",
                                      }}
                                    >
                                      <ConfusionMatrixIframe
                                        src={currentPCurvePNG.replace(
                                          /\?t=\d+$/,
                                          ""
                                        )}
                                        height="456px"
                                        scrolling="no"
                                        time={currentStatus}
                                      />
                                    </CardContent>
                                  </Card>
                                  <Box
                                    sx={{
                                      display: "grid",
                                      gap: "10px",
                                      gridTemplateColumns: "repeat(2, 1fr)",
                                    }}
                                  >
                                    <Card
                                      sx={{
                                        padding: "15px",
                                        // background: "#FAFAFB",
                                        boxShadow: "none",
                                      }}
                                    >
                                      <CardContent
                                        sx={{
                                          padding: "0",
                                          paddingBottom: "0 !important",
                                        }}
                                      >
                                        <Typography
                                          gutterBottom
                                          variant="h5"
                                          component="div"
                                        >
                                          Comparison
                                        </Typography>
                                        <AuthenticatedReportImage
                                          src={currentResultPNG.replace(
                                            /\?t=\d+$/,
                                            ""
                                          )}
                                          height="456px"
                                          width="100%"
                                        />
                                      </CardContent>
                                    </Card>

                                    <Card
                                      sx={{
                                        padding: "15px",
                                        // background: "#FAFAFB",
                                        boxShadow: "none",
                                      }}
                                    >
                                      <CardContent
                                        sx={{
                                          padding: "0",
                                          paddingBottom: "0 !important",
                                        }}
                                      >
                                        <Typography
                                          gutterBottom
                                          variant="h5"
                                          component="div"
                                        >
                                          Confusion Matrix
                                        </Typography>
                                        <ConfusionMatrixIframe
                                          src={currentConfusisonMetrixPNG.replace(
                                            /\?t=\d+$/,
                                            ""
                                          )}
                                          height="456px"
                                          scrolling="no"
                                          time={currentStatus}
                                        />
                                      </CardContent>
                                    </Card>
                                  </Box>
                                </Box>
                              );
                            }
                            return null;
                          })()}
                          {/* <Card
                          sx={{
                            padding: "15px",
                            background: "#FAFAFB",
                          }}
                        >
                          <CardContent
                            sx={{ padding: "0", paddingBottom: "0 !important" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                            >
                              Lizard
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              Lizards are a widespread group of squamate
                              reptiles, with over 6,000 species, ranging across
                              all continents except Antarctica
                            </Typography>
                          </CardContent>
                        </Card>

                        <Card
                          sx={{
                            padding: "15px",
                            background: "#FAFAFB",
                          }}
                        >
                          <CardContent
                            sx={{ padding: "0", paddingBottom: "0 !important" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                            >
                              Lizard
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              Lizards are a widespread group of squamate
                              reptiles, with over 6,000 species, ranging across
                              all continents except Antarctica
                            </Typography>
                          </CardContent>
                        </Card>
                        <Box sx={{ display:"grid", gap:"10px", gridTemplateColumns:"repeat(2, 1fr)" }}>
                          <Card
                            sx={{
                              padding: "15px",
                              background: "#FAFAFB",
                            }}
                          >
                            <CardContent
                              sx={{
                                padding: "0",
                                paddingBottom: "0 !important",
                              }}
                            >
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                              >
                                Comparision
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                Lizards are a widespread group of squamate
                                reptiles, with over 6,000 species, ranging
                                across all continents except Antarctica
                              </Typography>
                            </CardContent>
                          </Card>

                          <Card
                            sx={{
                              padding: "15px",
                              background: "#FAFAFB",
                            }}
                          >
                            <CardContent
                              sx={{
                                padding: "0",
                                paddingBottom: "0 !important",
                              }}
                            >
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                              >
                                Confusion Matrix
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                Lizards are a widespread group of squamate
                                reptiles, with over 6,000 species, ranging
                                across all continents except Antarctica
                              </Typography>
                            </CardContent>
                          </Card>
                        </Box> */}
                        </Box>
                      )}
                    </div>
                  </Box>
                </>
              ) : (
                <Box sx={{ flex: "0 0 78%" }}>
                  <Box>
                    <Box
                      sx={{
                        background: "white",
                        // marginTop: "15px",
                        borderRadius: "5px",
                        padding: "15px 15px 5px 15px",
                        height: "119px",
                      }}
                    >
                      <Box sx={{ display: "flex", gap: "20px" }}>
                        <Card
                          sx={{
                            flex: "0 0 25%",
                            padding: "13px",
                            marginBottom: "15px",
                            background: "#F5F6F9",
                            height: "100%",
                          }}
                        >
                          <CardHeader
                            sx={{ padding: "0" }}
                            avatar={
                              <Avatar
                                aria-label="recipe"
                                alt="Person 2"
                                src={totalImages}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: "-6px",
                                  borderRadius: "0",
                                }}
                              ></Avatar>
                            }
                            action={
                              <IconButton aria-label="settings">
                                {/* <KeyboardArrowDownIcon /> */}
                              </IconButton>
                            }
                          />
                          <CardContent
                            sx={{ padding: "0", paddingBottom: "0!important" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                              sx={{
                                color: "#45464E",
                                fontSize: "15px",
                                marginTop: "7px",
                              }}
                            >
                              Total Images
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#A1AEBE", fontSize: "16px" }}
                            >
                              <Typography
                                sx={{ color: "#A1AEBE", fontSize: "16px" }}
                              >
                                {projectDetails.images}
                              </Typography>
                            </Typography>
                          </CardContent>
                        </Card>
                        <Card
                          sx={{
                            flex: "0 0 25%",
                            padding: "13px",
                            background: "#F5F6F9",
                            height: "100%",
                          }}
                        >
                          <CardHeader
                            sx={{ padding: "0" }}
                            avatar={
                              <Avatar
                                aria-label="recipe"
                                alt="Person 2"
                                src={datasetIcon}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: "-6px",
                                  borderRadius: "0",
                                }}
                              ></Avatar>
                            }
                            action={
                              <IconButton aria-label="settings">
                                {/* <KeyboardArrowDownIcon /> */}
                              </IconButton>
                            }
                          />
                          <CardContent
                            sx={{ padding: "0", paddingBottom: "0!important" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                              sx={{
                                color: "#45464E",
                                fontSize: "15px",
                                marginTop: "7px",
                              }}
                            >
                              Total Annotations
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#A1AEBE", fontSize: "16px" }}
                            >
                              {projectDetails.annotations}
                            </Typography>
                          </CardContent>
                        </Card>
                        <div
                          id="presentStatus"
                          style={{
                            width: "100%",
                            overflowY: "scroll",
                            maxHeight: "119px",
                            minHeight: "119px",
                            borderRadius: "5px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Card
                            sx={{
                              flex: "0 0 50%",
                              padding: "3px 15px 0 15px",
                              background: "#F5F6F9",
                            }}
                          >
                            <CardHeader sx={{ padding: "0" }} />
                            <CardContent
                              sx={{
                                padding: "0",
                                paddingBottom: "0!important",
                              }}
                            >
                              <Typography sx={{ fontSize: "12px" }}>
                                Present Status
                              </Typography>
                              <HorizontalBarChart
                                data={sorted?.map((item) => item.count)} // Map to extract counts
                                labels={sorted?.map((item) => item.labelName)} // Map to extract label names
                                labelColor={sorted?.map(
                                  (item) => item.labelColor
                                )}
                              />
                            </CardContent>
                          </Card>
                        </div>
                      </Box>
                    </Box>

                    {selectedIndex == undefined ? (
                      <>
                        <>
                          <Box
                            sx={{
                              alignContent: "center",
                              marginTop: "16px",
                              background: "white",
                              borderRadius: "6px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                                justifyContent: "center",
                                alignContent: "center",
                                flexWrap: "wrap",
                                height: "calc(100vh - 286px)",
                              }}
                            >
                              <img src={train} alt="favIcon" />
                              <Box sx={{ width: "50%" }}>
                                <Typography
                                  sx={{ fontSize: "18px", color: "#000000" }}
                                >
                                  Ready to
                                  <ResponsiveTooltip
                                    title={
                                      !trainValidate
                                        ? "You do not have permission to create a new model"
                                        : !project.annotatedImageCount ||
                                          project.annotatedImageCount < 10
                                        ? "Minimum 10 images should be annotated to Enable this feature"
                                        : "A create section is already open"
                                    }
                                    disableHoverListener={
                                      !!(
                                        trainValidate &&
                                        (!modelsList.length ||
                                          !modelsList[0].trainingId?.startsWith(
                                            "0."
                                          )) &&
                                        project.annotatedImageCount &&
                                        project.annotatedImageCount >= 10
                                      )
                                    }
                                  >
                                    <span style={{ display: "inline-block" }}>
                                      <Box
                                        id="createNewModel"
                                        sx={{
                                          fontWeight: "600",
                                          color: "#0f6cbd",
                                          "&:hover": {
                                            cursor:
                                              !trainValidate ||
                                              (modelsList.length &&
                                                modelsList[0].trainingId?.startsWith(
                                                  "0."
                                                )) ||
                                              !project.annotatedImageCount ||
                                              project.annotatedImageCount < 10
                                                ? "not-allowed"
                                                : "pointer",
                                          },
                                        }}
                                        component="span"
                                        onClick={() => {
                                          if (
                                            !trainValidate ||
                                            (modelsList.length &&
                                              modelsList[0].trainingId?.startsWith(
                                                "0."
                                              )) ||
                                            !project.annotatedImageCount ||
                                            project.annotatedImageCount < 10
                                          ) {
                                            return;
                                          }
                                          addNewModel();
                                        }}
                                      >
                                        &nbsp;Train
                                      </Box>
                                    </span>
                                  </ResponsiveTooltip>
                                </Typography>
                                <span
                                  style={{
                                    color: "#0000003d",
                                    fontSize: "13px",
                                  }}
                                >
                                  Select a model from the list to continue
                                  training, or create a new one to start fresh.
                                  Get started by choosing your path.
                                </span>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            gap: "20px",
                            marginTop: "15px",
                          }}
                        >
                          <Box sx={{ width: "100%" }}>
                            <Card
                              sx={{
                                display: "flex",
                                // alignItems: "end",
                                padding: "12px",
                                boxShadow: "none",
                                gap: "10px",
                              }}
                            >
                              <CardContent
                                sx={{
                                  padding: "0px",
                                  display: "flex",
                                  // width: "96%",
                                  // width: "30ch",
                                  paddingBottom: "0!important",
                                  // gap: "10px",
                                }}
                              >
                                <FormControl
                                  sx={{ m: 1, width: "100%" }}
                                  variant="outlined"
                                >
                                  <Typography
                                    sx={{
                                      // fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Name
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <OutlinedInput
                                    id="outlinedAdornmentWeight"
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                      "aria-label": "weight",
                                      maxLength: 50, // Prevent overflow
                                      style: {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                    }}
                                    size="small"
                                    sx={{
                                      marginBottom: "15px",
                                      width: "100%",
                                      "& input": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      },
                                      cursor: selectedIndex !== undefined ? "text" : "not-allowed",
                                    }}
                                    value={dataIdDetails ? dataIdDetails.name : ""}
                                    onChange={(e) => {
                                      if (dataIdDetails.projectId !== "") {
                                        return;
                                      } else {
                                        const vals = e.target.value;
                                        const ovdf = vals
                                          .trimStart()
                                          .slice(0, 50)
                                          .replace(/\s{2,}/g, " ");
                                        setDataIdDetails({
                                          ...dataIdDetails,
                                          name: ovdf,
                                        });
                                      }
                                    }}
                                    disabled={selectedIndex === undefined || dataIdDetails.id != ""}
                                  />
                                  {validationErrors.name != "" ? (
                                    <span
                                      style={{ color: "red", fontSize: "10px" }}
                                    >
                                      {validationErrors.name}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </FormControl>
                                {selectedIndex.startsWith("0.") ? (
                                  <FormControl
                                    sx={{ m: 1, width: "100px" }}
                                    variant="outlined"
                                  >
                                    <ResponsiveTooltip title="An epoch is one full cycle where the model learns from complete data, improving each time.">
                                      <Typography
                                        id="epochSize"
                                        sx={{
                                          // fontWeight: "bold",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Epochs
                                        <span style={{ color: "red" }}>*</span>
                                      </Typography>
                                    </ResponsiveTooltip>
                                    <OutlinedInput
                                      id="outlinedAdornmentWeight"
                                      aria-describedby="outlined-weight-helper-text"
                                      inputProps={{
                                        "aria-label": "weight",
                                        type: "number", // Set input type to number
                                        min: 6,
                                        max: 250,
                                      }}
                                      value={
                                        dataIdDetails ? dataIdDetails.epochs : 6
                                      } // Bind the value to state
                                      onChange={handleChange22} // Handle input change
                                      onBlur={(e) => {
                                        let value = parseInt(
                                          e.target.value,
                                          10
                                        );

                                        if (isNaN(value) || value < 6) {
                                          value = 6;
                                        }

                                        setDataIdDetails((prev) => ({
                                          ...prev,
                                          epochs: value,
                                        }));

                                        // Convert number to string before assigning to input value
                                        e.target.value = value.toString();
                                      }}
                                      size="small"
                                      disabled={
                                        selectedIndex === undefined ||
                                        dataIdDetails.id != ""
                                      }
                                    />
                                  </FormControl>
                                ) : (
                                  ""
                                )}
                              </CardContent>
                              <CardActions>
                                {dataIdDetails &&
                                dataIdDetails.name != "" &&
                                //dataIdDetails.description != "" &&
                                dataIdDetails.advanceSetting &&
                                dataIdDetails.advanceSetting.modelQuality !=
                                  "" &&
                                dataIdDetails.advanceSetting.modelTypeId !=
                                  "" ? (
                                  Array.isArray(statusTrain) &&
                                  statusTrain.some(
                                    (training) =>
                                      training.trainingId === dataIdDetails.id
                                  ) ? (
                                    <>
                                      {isLoading ? <CircularProgress /> : <></>}
                                    </>
                                  ) : dataIdDetails.projectId === "" &&
                                    dataIdDetails.name.length > 2 &&
                                    //dataIdDetails.description.length > 0 &&
                                    dataIdDetails.advanceSetting.modelTypeId !=
                                      "" ? (
                                    <>
                                      <Button
                                        id="modelStartButton"
                                        variant="contained"
                                        disabled={isSubmitting} // Disable the button when submitting
                                        sx={{
                                          background: isSubmitting
                                            ? "#E0E0E0"
                                            : "white",
                                          color: isSubmitting
                                            ? "#BDBDBD"
                                            : "#666666",
                                          "&:hover": {
                                            background: isSubmitting
                                              ? "#E0E0E0"
                                              : "#F1F3F4",
                                          },
                                        }}
                                        onClick={() => {
                                          if (!isSubmitting) {
                                            // Show crunching animation immediately
                                            setStatusCMImg(false);
                                            setStatusRImg(false);
                                            setStatusPCImg(false);
                                            setStatusRCImg(false);
                                            handleSubmit();
                                            setHitf(false);
                                          }
                                        }}
                                      >
                                        <img
                                          src={startTrainingActive}
                                          alt=""
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            objectFit: "contain",
                                            cursor: isSubmitting
                                              ? "not-allowed"
                                              : "pointer",
                                            padding: "6px 0px",
                                            marginRight: "10px",
                                          }}
                                        />
                                        {isSubmitting
                                          ? "Submitting..."
                                          : "Start Training"}
                                      </Button>
                                    </>
                                  ) : selectedIndex.startsWith("0.") ? (
                                    <>
                                      <Button
                                        id="modelStartButton"
                                        variant="contained"
                                        // disabled
                                        sx={{
                                          background: "white",
                                          color: "#666666",

                                          "&:hover": {
                                            // color: "white",
                                            background: "white",
                                            cursor: "not-allowed",
                                          },
                                        }}
                                        onClick={(e) => {
                                          checkValidations();
                                          setHitf(true);
                                        }}
                                      >
                                        <img
                                          // src={startTrainingInActive}
                                          src={startTrainingInActive}
                                          alt=""
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            objectFit: "contain",
                                            // cursor: "pointer",
                                            padding: "6px 0px",
                                            marginRight: "10px",
                                          }}
                                        />
                                        Start Training
                                      </Button>
                                    </>
                                  ) : "progress" in dataIdDetails &&
                                    Array.isArray(statusTrain) &&
                                    statusTrain.some(
                                      (training) =>
                                        training.trainingId === dataIdDetails.id
                                    ) ? (
                                    <></>
                                  ) : !selectedIndex.startsWith("0.") ? (
                                    <>
                                      {dataIdDetails.isPublished ? (
                                        <Button
                                          id="trainDownloadModel"
                                          onClick={() => {
                                            const modelId = dataIdDetails?.id;
                                            if (modelId) {
                                              // Call handleDownload only if modelId is a valid string
                                              handleDownload(modelId);
                                            }
                                          }}
                                          variant="contained"
                                          sx={{
                                            background: "white",
                                            color: "#666666",
                                            "&:hover": {
                                              background: "white",
                                            },
                                            ...(downloadingIds.includes(
                                              dataIdDetails?.id || ""
                                            ) && {
                                              background:
                                                "linear-gradient(90deg, lightgreen, lightyellow)",
                                              backgroundSize: "200% 100%",
                                              animation:
                                                "slideBackground 3s ease-in-out infinite",
                                            }),
                                          }}
                                          className={
                                            downloadingIds.includes(
                                              dataIdDetails?.id || ""
                                            )
                                              ? "button-downloading"
                                              : ""
                                          }
                                          startIcon={
                                            <FileDownloadOutlined fontSize="small" />
                                          }
                                          disabled={downloadingIds.includes(
                                            dataIdDetails?.id || ""
                                          )}
                                        >
                                          {downloadingIds.includes(
                                            dataIdDetails?.id || ""
                                          )
                                            ? "Downloading"
                                            : "Download"}
                                        </Button>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  ) // <Box
                                ) : (
                                  ""
                                )}
                              </CardActions>
                            </Card>
                          </Box>
                        </Box>

                        {selectedIndex !== undefined ? (
                          <Box>
                            <Box
                              sx={{
                                background: "white",
                                marginTop: "15px",
                                borderRadius: "5px",
                                padding: "15px",
                                height: "calc(100vh - 445px)",
                                overflowY: "scroll",
                                overflowX: "hidden",
                              }}
                            >
                              {selectedIndex &&
                              !selectedIndex.startsWith("0.") &&
                              modelsList.some(
                                (model) => model.id === selectedIndex
                              ) ? (
                                <>
                                  <Box
                                    sx={{
                                      background: "white",
                                      flexGrow: "1",
                                      alignContent: "center",
                                      borderRadius: "4px",
                                      width: "100%",
                                      position: "relative",
                                    }}
                                  >
                                    <IconButton
                                      onClick={handleOpenConfusionMatrix}
                                      color="primary"
                                      sx={{
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        zIndex: 10,
                                      }}
                                    >
                                      <FullscreenIcon fontSize="large" />
                                    </IconButton>
                                    <ConfusionMatrix
                                      statusCMImg={statusCMImg}
                                      statusRImg={statusRImg}
                                      statusPCImg={statusPCImg}
                                      statusRCImg={statusRCImg}
                                      LoaderGIF={LoaderGIF}
                                      modelType={modelType}
                                      currentConfusisonMetrixPNG={
                                        currentConfusisonMetrixPNG
                                      }
                                      currentResultPNG={currentResultPNG}
                                      currentPCurvePNG={currentPCurvePNG}
                                      currentRCurvePNG={currentRCurvePNG}
                                      boxHeight={"520"}
                                    />
                                  </Box>
                                </>
                              ) : Array.isArray(statusTrain) &&
                                statusTrain.some(
                                  (training) =>
                                    training.trainingId === dataIdDetails.id
                                ) ? (
                                <></>
                              ) : selectedIndex.startsWith("0.") ? (
                                <>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "20px",
                                      // padding: "20px",
                                      width: "100%",
                                    }}
                                  >
                                    {/* Container for both Advanced Settings and Select Quality */}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "30px", // Add space between the two groups
                                        justifyContent: "space-between",
                                        width: "100%",
                                      }}
                                    >
                                      {/* Advanced Settings Group */}

                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "10px",
                                          alignItems: "flex-start",
                                          width: "30%", // Smaller width for Advanced Settings
                                        }}
                                      >
                                        {/* Label */}
                                        <ResponsiveTooltip title="The specific kind of model used to analyze images and solve a particular task.">
                                          <Typography
                                            sx={{
                                              // fontWeight: "bold",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Model Type
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </Typography>
                                        </ResponsiveTooltip>
                                        {/* Dropdown */}
                                        {detailModels.length > 0 ? (
                                          <FormControl sx={{ width: "100%" }}>
                                            <Select
                                              id="modelType"
                                              value={
                                                dataIdDetails?.advanceSetting
                                                  ?.modelTypeId || ""
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                                if (
                                                  e.target.value !== "" &&
                                                  hitf
                                                ) {
                                                  setValidationErrors({
                                                    ...validationErrors,
                                                    modelTypeId: "",
                                                  });
                                                }
                                              }}
                                              onOpen={() =>
                                                localStorage.setItem(
                                                  "popupOpenMenu",
                                                  true.toString()
                                                )
                                              }
                                              onClose={() =>
                                                localStorage.setItem(
                                                  "popupOpenMenu",
                                                  false.toString()
                                                )
                                              }
                                              displayEmpty
                                              inputProps={{
                                                "aria-label": "Without label",
                                              }}
                                              size="small"
                                              sx={{
                                                background: "#F1F3F4",
                                                "& .MuiSelect-select": {
                                                  color: "#666",
                                                },
                                                "& .MuiOutlinedInput-notchedOutline":
                                                  {
                                                    border: "none",
                                                  },
                                              }}
                                              disabled={
                                                selectedIndex === undefined ||
                                                dataIdDetails.id !== ""
                                              }
                                            >
                                              <MenuItem value={""} disabled>
                                                Select Model Type
                                              </MenuItem>
                                              {detailModels.map((item) => (
                                                <MenuItem
                                                  key={item.id}
                                                  value={item.id}
                                                  disabled={disabledIds.includes(
                                                    item.id.toLowerCase()
                                                  )} // Disable condition
                                                >
                                                  <ResponsiveTooltip
                                                    title={getTooltipById(
                                                      item.id
                                                    )}
                                                  >
                                                    <span
                                                      style={{ width: "100%" }}
                                                    >
                                                      {item.name}
                                                    </span>
                                                  </ResponsiveTooltip>
                                                </MenuItem>
                                              ))}
                                            </Select>
                                            {validationErrors.modelTypeId && (
                                              <Typography
                                                sx={{
                                                  color: "red",
                                                  fontSize: "12px",
                                                  marginTop: "5px",
                                                }}
                                              >
                                                {validationErrors.modelTypeId}
                                              </Typography>
                                            )}
                                            {dataIdDetails?.advanceSetting
                                              ?.modelTypeId && (
                                              <Typography
                                                sx={{
                                                  color: "green",
                                                  fontSize: "12px",
                                                  marginTop: "5px",
                                                }}
                                              >
                                                {getTooltipById(
                                                  dataIdDetails?.advanceSetting
                                                    ?.modelTypeId
                                                )}
                                              </Typography>
                                            )}
                                          </FormControl>
                                        ) : (
                                          <Typography sx={{ color: "red" }}>
                                            Models not Found
                                          </Typography>
                                        )}
                                      </Box>

                                      {/* Select Quality Group */}
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "10px",
                                          alignItems: "flex-start",
                                          width: "70%", // Larger width for Select Quality
                                        }}
                                      >
                                        {/* Label */}
                                        <ResponsiveTooltip title="Different versions of the model that vary in complexity and performance.">
                                          <Typography
                                            sx={{
                                              // fontWeight: "bold",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Model Size
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </Typography>
                                        </ResponsiveTooltip>
                                        {/* Radio Buttons */}
                                        <RadioGroup
                                          id="modelSize"
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "15px",
                                            flexWrap: "wrap", // Allow wrapping if the options overflow
                                          }}
                                          name="radio-buttons-group"
                                        >
                                          {options.map((option) => (
                                            <FormControlLabel
                                              key={option}
                                              value={option}
                                              control={
                                                <Radio
                                                  sx={{
                                                    color: "#A3A3A3",
                                                    "&.Mui-checked": {
                                                      color: "#00000099",
                                                    },
                                                  }}
                                                  size="small"
                                                  checked={isChecked(option)}
                                                  disabled={isDisabled()}
                                                />
                                              }
                                              label={
                                                <ResponsiveTooltip
                                                  title={
                                                    option.toLowerCase() ===
                                                    "extrasmall"
                                                      ? "Ultra-light, optimized for edge devices"
                                                      : option.toLowerCase() ===
                                                        "small"
                                                      ? "Fast & compact, ideal for real-time use"
                                                      : option.toLowerCase() ===
                                                        "medium"
                                                      ? "Balanced speed & accuracy"
                                                      : option.toLowerCase() ===
                                                        "large"
                                                      ? "High-accuracy, suited for complex tasks"
                                                      : option.toLowerCase() ===
                                                        "extralarge"
                                                      ? "Most powerful, optimized for high-end GPUs"
                                                      : ""
                                                  }
                                                >
                                                  <span>
                                                    {option.replace(
                                                      "Extra",
                                                      "Extra "
                                                    )}
                                                  </span>
                                                </ResponsiveTooltip>
                                              }
                                              onChange={() =>
                                                handleModelQuality(option)
                                              }
                                              sx={{
                                                color: "#00000099",
                                                fontSize: "12px",
                                              }}
                                            />
                                          ))}
                                        </RadioGroup>

                                        {dataIdDetails?.advanceSetting
                                          ?.modelQuality && (
                                          <Typography
                                            sx={{
                                              color: "green",
                                              fontSize: "12px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            {dataIdDetails?.advanceSetting?.modelQuality.toLowerCase() ==
                                            "extrasmall"
                                              ? "Ultra-fast, minimal parameters, low accuracy"
                                              : dataIdDetails?.advanceSetting?.modelQuality.toLowerCase() ==
                                                "small"
                                              ? "Lightweight, efficient, good for edge devices"
                                              : dataIdDetails?.advanceSetting?.modelQuality.toLowerCase() ==
                                                "medium"
                                              ? "Balanced accuracy and efficiency, mid-range devices"
                                              : dataIdDetails?.advanceSetting?.modelQuality.toLowerCase() ==
                                                "large"
                                              ? "High accuracy, GPU required, slower inference"
                                              : dataIdDetails?.advanceSetting?.modelQuality.toLowerCase() ==
                                                "extralarge"
                                              ? "Maximum accuracy, huge parameters, cloud-based"
                                              : ""}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Box sx={{ margin: "2% 0" }}>
                                    <div
                                      id="splitDataset"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography sx={{ marginBottom: "2%" }}>
                                        Split Dataset
                                      </Typography>
                                      <RangeSelect
                                        selectedIndexs={selectedIndex}
                                        dataId={dataIdDetails.id}
                                      />
                                    </div>
                                    {/* <SplitSlider
                                  selectedIndexs={selectedIndex}
                                  dataId={dataIdDetails.id}
                                /> */}
                                    <FormControl sx={{ marginTop: "10px" }}>
                                      <Typography>Augmentations</Typography>
                                      <FormLabel
                                        id="demo-radio-buttons-group-label"
                                        sx={{ color: "#000", display: "none" }}
                                      >
                                        Augmentations
                                      </FormLabel>
                                      <div
                                        id="labelAugmentations"
                                        style={{
                                          width: "100%",
                                          height: "1px",
                                        }}
                                      ></div>
                                      <RadioGroup
                                        id="labelAugmentations"
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                        sx={{
                                          flexDirection: "row",
                                          color: "#A3A3A3",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <img
                                                  src={oneimg}
                                                  alt="Tooltip Example"
                                                  style={{ width: "200px" }}
                                                />
                                              }
                                            >
                                              <FormControlLabel
                                                value="HorizontalFlip"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.horizontalFlip ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="horizontalFlip"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id !== ""
                                                    }
                                                  />
                                                }
                                                label="Horizontal Flip"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>

                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={threeimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomRotate"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomRotate || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomRotate"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Rotate"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={fourimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomCrop"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomCrop || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomCrop"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Crop"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={fiveimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomShear"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomShear || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomShear"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id !== ""
                                                    }
                                                  />
                                                }
                                                label="Random Shear"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={twentyoneimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomScale"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomScale || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomScale"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Scale"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={siximg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="Resize"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.resize || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="resize"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Resize"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={sevenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomBrightnessContrast"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomBrightnessContrast ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomBrightnessContrast"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Brightness Contrast"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={eightimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="HueSaturationValue"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.hueSaturationValue ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="hueSaturationValue"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Hue Saturation Value"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={twentyimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="Blur"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations?.blur ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="blur"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Blur"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={nineimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomGamma"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomGamma || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomGamma"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Gamma"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={tenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="OpticalDistortion"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.opticalDistortion ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="opticalDistortion"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Optical Distortion"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={elevenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="GridDistortion"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.gridDistortion ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="gridDistortion"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Grid Distortion"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={twoimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="VerticalFlip"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.verticalFlip || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="verticalFlip"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id !== ""
                                                    }
                                                  />
                                                }
                                                label="Vertical Flip"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={twelveimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="RandomRotate90"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.randomRotate90 ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="randomRotate90"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Random Rotate 90"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={thirteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="GaussNoise"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.gaussNoise || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="gaussNoise"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Gauss Noise"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={fourteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="Equalize"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.equalize || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="equalize"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Equalize"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={fifteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="Sharpen"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.sharpen || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="sharpen"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Sharpen"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={sixteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="ToGray"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.toGray || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="toGray"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="To Gray"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={seventeenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="ToSepia"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.toSepia || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="toSepia"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="To Sepia"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={eighteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="ShiftScaleRotate"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.shiftScaleRotate ||
                                                      false
                                                    }
                                                    onChange={handleCheck}
                                                    name="shiftScaleRotate"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id != ""
                                                    }
                                                  />
                                                }
                                                label="Shift Scale Rotate"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={2}>
                                            <ResponsiveTooltip
                                              title={
                                                <>
                                                  <img
                                                    src={nineteenimg}
                                                    alt="Tooltip Image"
                                                    style={{ width: "200px" }}
                                                  />
                                                </>
                                              }
                                            >
                                              <FormControlLabel
                                                value="Transpose"
                                                control={
                                                  <Checkbox
                                                    size="small"
                                                    checked={
                                                      dataIdDetails
                                                        ?.advanceSetting
                                                        ?.augmentations
                                                        ?.transpose || false
                                                    }
                                                    onChange={handleCheck}
                                                    name="transpose"
                                                    sx={{
                                                      color: "#A3A3A3", // Default color (unchecked)
                                                      "&.Mui-checked": {
                                                        color: "#00000099", // Color when checked
                                                      },
                                                    }}
                                                    disabled={
                                                      selectedIndex ===
                                                        undefined ||
                                                      dataIdDetails.id !== ""
                                                    }
                                                  />
                                                }
                                                label="Transpose"
                                                sx={{
                                                  color: "#00000099",
                                                  "& .MuiFormControlLabel-label":
                                                    {
                                                      fontSize: "14px", // Set label font size here
                                                    },
                                                }}
                                              />
                                            </ResponsiveTooltip>
                                          </Grid>
                                        </Grid>
                                      </RadioGroup>
                                    </FormControl>
                                  </Box>
                                </>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Box>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ height: "calc(100vh - 160px)", alignContent: "center" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  color: "#ff000080",
                  margin: "10px",
                }}
              >
                No Annotations Available
                <br />
                <span style={{ color: "#00000080", fontSize: "16px" }}>
                  Please Annotate some images
                </span>
              </p>
            </Box>
          </>
        )}
        <div>
            <Dialog
            open={renames}
            onClose={handleRenameClose}
            aria-labelledby="rename-dialog-title"
            >
            <DialogTitle id="rename-dialog-title">{"Rename Model"}</DialogTitle>
            <DialogContent>
              <TextField
              id="projectName"
              autoFocus
              margin="dense"
              style={{
                border:
                isSubmitted && modelName.length < 3
                  ? "1px solid red"
                  : "0",
                width: "400px",
              }}
              type="text"
              fullWidth
              value={modelName}
              onChange={(e) => {
                const val = e.target.value
                .trimStart()
                .slice(0, 50)
                .replace(/\s{2,}/g, " ");
                setModelName(val);
              }}
              />
              <br />
              {isSubmitted && modelName.length < 3 && (
              <span style={{ color: "red", fontSize: "10px" }}>
                Minimum 3 characters
              </span>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleRenameClose} color="primary">
              Cancel
              </Button>
              <Button
              onClick={handleSubmitRename}
              color="primary"
              variant="contained"
              disabled={modelName.length < 3}
              >
              Submit
              </Button>
            </DialogActions>
            </Dialog>
        </div>
      </div>

      <div>
        {/* Delete confirmation modal */}
        <Dialog
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">{"Confirm Delete"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              Are you sure you want to delete this item? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="calcelDeleteModel"
              onClick={closeDeleteModal}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              id="confirmDeleteModel"
              onClick={() => (isDeleting ? "" : confirmDelete())}
              color="error"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Dialog
        open={openConfusionMatrix}
        onClose={handleCloseConfusionMatrix}
        fullScreen
        sx={{
          "& .MuiPaper-root": {
            height: "100vh", // Full height
            background: "#00000030", // Dark overlay effect
            backdropFilter: "blur(5px)", // Blur effect
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Close Button on Top-Right */}
        <IconButton
          onClick={handleCloseConfusionMatrix}
          sx={{
            position: "absolute",
            top: 37,
            right: 24,
            color: "white",
            zIndex: 10,
            background: "#000",
            "&:hover": {
              background: "#333", // Change to desired hover background color
            },
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        {/* Content */}
        <DialogContent sx={{ flex: 1, overflow: "auto" }}>
          <ConfusionMatrix
            statusCMImg={statusCMImg}
            statusRImg={statusRImg}
            statusPCImg={statusPCImg}
            statusRCImg={statusRCImg}
            LoaderGIF={LoaderGIF}
            modelType={modelType}
            currentConfusisonMetrixPNG={currentConfusisonMetrixPNG}
            currentResultPNG={currentResultPNG}
            currentPCurvePNG={currentPCurvePNG}
            currentRCurvePNG={currentRCurvePNG}
            boxHeight={"100"}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={maxModelCount}
        onClose={handleMaxModelCountClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            boxShadow: "none",
            width: "50%",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "#2121210f",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Maximum Limit Reached</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ padding: "10px 0" }}
          >
            Oops! Your current plan supports a maximum of <b>{maxModelLimit}</b>{" "}
            models. Upgrade to add more models!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMaxModelCountClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleRedirectPlanPage}
            variant="contained"
            color="error"
          >
            I want more Models @ $9
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withSpinner(Train);
